import { LocationType, SAVED_LOCATION } from '@guryou/core';

export * from './Action';
export * from './actionHelpers';
export * from './ActionStatus';
export * from './basicReducer';
export * from './buildActionType';
export * from './countReducer';
export * from './Notification';
export * from './NotificationType';
export * from './stateChecks';
export * from './StateStatus';

export const handleLocationInput = data => {
  const { latitude, longitude, locationType, locationNote, address, url } = data;
  const request = {};

  if (+locationType === LocationType.mapLocation || locationType === SAVED_LOCATION) {
    request.latitude = +latitude;
    request.longitude = +longitude;
    request.address = address;
  } else if (+locationType === LocationType.plainNote || +locationType === LocationType.onlineLocation) {
    request.locationNote = locationNote;
    request.url = url;
  }
  return request;
};
